import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ezpkocebutzfstozrewd.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV6cGtvY2VidXR6ZnN0b3pyZXdkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTkyMDUzNTMsImV4cCI6MjA3NDc4MTM1M30.GPQlWH1wmJj16zrReOMLi8yAmeJyvbAloBhepYiP1j4';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);